import { LayoutComponent } from "@jelly/lesson";

import f100Hz_d5cm from "./100hz-5cm";
import f100Hz_d8cm from "./100hz-8cm";
import f100Hz_d13cm from "./100hz-13cm";
import f100Hz_d21cm from "./100hz-21cm";
import f100Hz_d36cm from "./100hz-36cm";
import f100Hz_d60cm from "./100hz-60cm";
import f100Hz_d100cm from "./100hz-100cm";
import f200Hz_d5cm from "./200hz-5cm";
import f200Hz_d8cm from "./200hz-8cm";
import f200Hz_d13cm from "./200hz-13cm";
import f200Hz_d21cm from "./200hz-21cm";
import f200Hz_d36cm from "./200hz-36cm";
import f200Hz_d60cm from "./200hz-60cm";
import f200Hz_d100cm from "./200hz-100cm";
import f300Hz_d5cm from "./300hz-5cm";
import f300Hz_d8cm from "./300hz-8cm";
import f300Hz_d13cm from "./300hz-13cm";
import f300Hz_d21cm from "./300hz-21cm";
import f300Hz_d36cm from "./300hz-36cm";
import f300Hz_d60cm from "./300hz-60cm";
import f300Hz_d100cm from "./300hz-100cm";
import f400Hz_d5cm from "./400hz-5cm";
import f400Hz_d8cm from "./400hz-8cm";
import f400Hz_d13cm from "./400hz-13cm";
import f400Hz_d21cm from "./400hz-21cm";
import f400Hz_d36cm from "./400hz-36cm";
import f400Hz_d60cm from "./400hz-60cm";
import f400Hz_d100cm from "./400hz-100cm";
import f500Hz_d5cm from "./500hz-5cm";
import f500Hz_d8cm from "./500hz-8cm";
import f500Hz_d13cm from "./500hz-13cm";
import f500Hz_d21cm from "./500hz-21cm";
import f500Hz_d36cm from "./500hz-36cm";
import f500Hz_d60cm from "./500hz-60cm";
import f500Hz_d100cm from "./500hz-100cm";
import f750Hz_d5cm from "./750hz-5cm";
import f750Hz_d8cm from "./750hz-8cm";
import f750Hz_d13cm from "./750hz-13cm";
import f750Hz_d21cm from "./750hz-21cm";
import f750Hz_d36cm from "./750hz-36cm";
import f750Hz_d60cm from "./750hz-60cm";
import f750Hz_d100cm from "./750hz-100cm";
import f1000Hz_d5cm from "./1000hz-5cm";
import f1000Hz_d8cm from "./1000hz-8cm";
import f1000Hz_d13cm from "./1000hz-13cm";
import f1000Hz_d21cm from "./1000hz-21cm";
import f1000Hz_d36cm from "./1000hz-36cm";
import f1000Hz_d60cm from "./1000hz-60cm";
import f1000Hz_d100cm from "./1000hz-100cm";
import f1500Hz_d5cm from "./1500hz-5cm";
import f1500Hz_d8cm from "./1500hz-8cm";
import f1500Hz_d13cm from "./1500hz-13cm";
import f1500Hz_d21cm from "./1500hz-21cm";
import f1500Hz_d36cm from "./1500hz-36cm";
import f1500Hz_d60cm from "./1500hz-60cm";
import f1500Hz_d100cm from "./1500hz-100cm";
import f2000Hz_d5cm from "./2000hz-5cm";
import f2000Hz_d8cm from "./2000hz-8cm";
import f2000Hz_d13cm from "./2000hz-13cm";
import f2000Hz_d21cm from "./2000hz-21cm";
import f2000Hz_d36cm from "./2000hz-36cm";
import f2000Hz_d60cm from "./2000hz-60cm";
import f2000Hz_d100cm from "./2000hz-100cm";
import f5000Hz_d5cm from "./5000hz-5cm";
import f5000Hz_d8cm from "./5000hz-8cm";
import f5000Hz_d13cm from "./5000hz-13cm";
import f5000Hz_d21cm from "./5000hz-21cm";
import f5000Hz_d36cm from "./5000hz-36cm";
import f5000Hz_d60cm from "./5000hz-60cm";
import f5000Hz_d100cm from "./5000hz-100cm";

const component: LayoutComponent[] = [
  {
    variant: "layout",
    data: {
      type: "controlsToggleExtraContent",
      options: {
        controlsPosition: "bottom",
        controls: [
          {
            type: "dropdown",
            options: {
              label: "Frequency",
            },
            items: [
              { name: "100 Hz" },
              { name: "200 Hz" },
              { name: "300 Hz" },
              { name: "400 Hz" },
              { name: "500 Hz" },
              { name: "750 Hz" },
              { name: "1000 Hz" },
              { name: "1500 Hz" },
              { name: "2000 Hz" },
              { name: "5000 Hz" },
            ],
          },
          {
            type: "dropdown",
            options: {
              label: "Distance between sources (d)",
            },
            items: [
              { name: "5 cm" },
              { name: "8 cm" },
              { name: "13 cm" },
              { name: "21 cm" },
              { name: "36 cm" },
              { name: "60 cm" },
              { name: "100 cm" },
            ],
          },
        ],
        extraContent: [
          [[], [], [], [], [], [], []],
          [[], [], [], [], [], [], []],
          [[], [], [], [], [], [], []],
          [[], [], [], [], [], [], []],
          [[], [], [], [], [], [], []],
          [[], [], [], [], [], [], []],
          [[], [], [], [], [], [], []],
          [[], [], [], [], [], [], []],
          [[], [], [], [], [], [], []],
          [[], [], [], [], [], [], []],
        ],
        components: [
          [f100Hz_d5cm, f100Hz_d8cm, f100Hz_d13cm, f100Hz_d21cm, f100Hz_d36cm, f100Hz_d60cm, f100Hz_d100cm],
          [f200Hz_d5cm, f200Hz_d8cm, f200Hz_d13cm, f200Hz_d21cm, f200Hz_d36cm, f200Hz_d60cm, f200Hz_d100cm],
          [f300Hz_d5cm, f300Hz_d8cm, f300Hz_d13cm, f300Hz_d21cm, f300Hz_d36cm, f300Hz_d60cm, f300Hz_d100cm],
          [f400Hz_d5cm, f400Hz_d8cm, f400Hz_d13cm, f400Hz_d21cm, f400Hz_d36cm, f400Hz_d60cm, f400Hz_d100cm],
          [f500Hz_d5cm, f500Hz_d8cm, f500Hz_d13cm, f500Hz_d21cm, f500Hz_d36cm, f500Hz_d60cm, f500Hz_d100cm],
          [f750Hz_d5cm, f750Hz_d8cm, f750Hz_d13cm, f750Hz_d21cm, f750Hz_d36cm, f750Hz_d60cm, f750Hz_d100cm],
          [f1000Hz_d5cm, f1000Hz_d8cm, f1000Hz_d13cm, f1000Hz_d21cm, f1000Hz_d36cm, f1000Hz_d60cm, f1000Hz_d100cm],
          [f1500Hz_d5cm, f1500Hz_d8cm, f1500Hz_d13cm, f1500Hz_d21cm, f1500Hz_d36cm, f1500Hz_d60cm, f1500Hz_d100cm],
          [f2000Hz_d5cm, f2000Hz_d8cm, f2000Hz_d13cm, f2000Hz_d21cm, f2000Hz_d36cm, f2000Hz_d60cm, f2000Hz_d100cm],
          [f5000Hz_d5cm, f5000Hz_d8cm, f5000Hz_d13cm, f5000Hz_d21cm, f5000Hz_d36cm, f5000Hz_d60cm, f5000Hz_d100cm],
        ],
      },
    },
  },
];

export default component;
